"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'style.form.title.edit': '编辑写作样式',
    'style.form.title.add': '添加写作样式',
    'style.form.back': '返回',
    'style.form.name.label': '名称',
    'style.form.name.placeholder': '样式名称',
    'style.form.description.label': '描述',
    'style.form.description.placeholder': '描述这种写作样式',
    'style.form.prompt.label': '样式提示词',
    'style.form.prompt.placeholder': '输入定义此写作样式的AI提示词...',
    'style.form.common.label': '通用样式',
    'style.form.common.description': '通用样式对所有用户可用，但只能由超级管理员编辑',
    'style.form.active.label': '活跃',
};
